import { makeStyles } from '@material-ui/core/styles';
import { VerticalBarChart } from '../../../common/components/VerticalBarChart';
import { useQuery } from '@tanstack/react-query';
import { getLastSixMonth } from '../../../common/functions/getLastSixMonth';
import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import { getPurchaseOrderDashboard } from '../../../app/services/purchase-order/get-purchase-order.api';
import { checkInfoByMonthAndStatus } from '../checkInfoByMonthAndStatus';
import { Skeleton } from '@material-ui/lab';
import { optionsInt } from '../../../common/functions/getOptionsCharts';
import { getRandomColor } from '../../../common/functions/generateRandomColor';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    card: {
        width: '100%',
        maxWidth: 700,
        maxHeight: 500,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            minHeight: 375,
        }
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    skeleton: {
        marginBottom: 6,
        [theme.breakpoints.up('md')]: {
            minHeight: 375,
        }
    },
}));

export const DashboardPurchaseOrder = () => {
    const classes = useStyles()
  
    const sixMonthsBefore = getLastSixMonth()
    const [colors] = useState(Array.from({ length: 12 }).map(() => getRandomColor()));

    const { data, isFetching } = useQuery(['dashboardPurchaseOrder'], async () => {
        // obtem as requisicao rascunho
        const token = localStorage.getItem('token')
        if(token){
            const res = await getPurchaseOrderDashboard(token, {
                date: sixMonthsBefore.date,
            })
            if(res){
                return res
            }
        }
        return []
      }, {
        refetchOnWindowFocus: false,
    })

    const data2 = {
        labels: sixMonthsBefore.sixMonthsBefore,
        datasets: [
            {
                label: 'Aprovados',
                data: checkInfoByMonthAndStatus('APROVADO', data, sixMonthsBefore),
                backgroundColor: colors[0],
            },
            {
                label: 'Reprovados',
                data: checkInfoByMonthAndStatus('REPROVADO', data, sixMonthsBefore),
                backgroundColor: colors[1],
            },
        ],
    };
  
    return (
        <Card className={classes.card}>
            <CardHeader
                title="Número de ordem de compras"
            />
            <CardContent className={classes.content}>
                <Box className={classes.itemContainer}>
                    {
                        isFetching ? (
                                <Skeleton animation="wave" height="100%" variant='rect' width="100%" className={classes.skeleton} />
                            ) : (
                                <VerticalBarChart
                                    options={optionsInt}
                                    data={data2}
                                />
                            )
                    }
                </Box>
            </CardContent>
        </Card>
    );
};
